import { BaseEditable } from '@fmcc-web-platform/react-components';
import React from 'react';
import { MarkerProps } from '../types/Tile';
import { useQueryMarker } from '../hooks/useQueryMarker';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withQueryMarker = (Component: React.FC<any>) => {
  const QueryMarker = (props: { model: MarkerProps } & BaseEditable) => {
    const customProps = useQueryMarker(props);

    return (
      <Component
        {...customProps}
        {...customProps.model}
      />
    );
  };
  QueryMarker.displayName = `withQueryMarker(${Component.displayName || Component.name})`;
  return QueryMarker;
};

export default withQueryMarker;
